import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxIconBoxComponent,
  OnyxIconComponent,
  OnyxSpinnerComponent,
  OnyxTooltipDirective,
} from '@onyx/angular';
import type { Subject } from 'rxjs';
import type {
  Fleet,
  SimplifiedFleet,
} from '../../../../dashboard/fleet/common/interfaces/fleet';
import { IntegrationsRoute } from '../../../../dashboard/management-panel/integrations/common/enums/integrations-route';
import { TelematicsStore } from '../../../stores/telematics.store';

@Component({
  selector: 'app-modal-telematics-status',
  imports: [
    OnyxSpinnerComponent,
    OnyxIconComponent,
    TranslatePipe,
    OnyxTooltipDirective,
    OnyxIconBoxComponent,
    NgTemplateOutlet,
  ],
  templateUrl: './modal-telematics-status.component.html',
  styleUrl: './modal-telematics-status.component.scss',
})
export class ModalTelematicsStatusComponent {
  protected readonly store = inject(TelematicsStore);

  public readonly vehicle = input.required<Fleet | SimplifiedFleet | null>();
  public readonly type = input.required<'banner' | 'icon-box'>();
  public readonly close$ = input.required<Subject<void>>();

  protected readonly I18N = 'fleet.fleetModal';

  protected readonly IntegrationsRoute = IntegrationsRoute;

  protected telematicsItem = computed(() =>
    this.store.getItem(this.vehicle()?.uuid),
  );

  protected status = computed(() => {
    if (!this.vehicle()) {
      return {
        icon: 'vehicle-ride-filled',
        label: `${this.I18N}.noVehicleStatus`,
        color: 'light-gray',
      } as const;
    }

    if (!this.vehicle()?.telematics) {
      return {
        icon: 'vehicle-ride-filled',
        label: `${this.I18N}.noTelematics`,
        color: 'light-gray',
        hasRedirectButton: true,
      } as const;
    }

    const telematicsItem = this.telematicsItem();
    if (!telematicsItem) {
      return {
        icon: 'tacho-connection-waiting-outlined',
        label: `${this.I18N}.noResponse`,
        color: 'light-gray',
      } as const;
    }

    const icon = telematicsItem.status.icon;
    return {
      icon: icon.name,
      label: `${icon.tooltip}`,
      color: icon.color,
      offRouteData: telematicsItem.status.offRouteData,
    };
  });
}
